import React from "react";
import firebase from "../../firebase";
import { Icon, Button } from "semantic-ui-react";

import { connect } from "react-redux";

class ArticlesLikeButton extends React.Component {
  state = {
    user: this.props.currentUser,
    articlesRef: firebase.database().ref("articles"),
    usersRef: firebase.database().ref("users"),
    likedArticles: [],
    article: this.props.article,
  };

  componentDidMount() {
    if (this.state.user) {
      this.addListeners();
    }
  }

  componentWillUnmount() {
    this.removeListeners();
  }

  addListeners = () => {
    let likedArticles = [];
    this.state.usersRef
      .child(`${this.state.user.uid}/likedArticles`)
      .on("child_added", (snap) => {
        let article = snap.val();
        article["added"] = false;
        article["key"] = snap.key;
        likedArticles.push(article);
        this.setState({ likedArticles: likedArticles });
      });

    likedArticles = [];
    this.state.usersRef
      .child(`${this.state.user.uid}/likedArticles`)
      .on("child_removed", (snap) => {
        let article = snap.val();
        // console.log(article)
        article["uid"] = article.uid;
        likedArticles = this.state.likedArticles.filter(
          (f) => f.id !== article.id
        );
        this.setState({ likedArticles: likedArticles });
      });
  };

  removeListeners = () => {
    // this.state.articlesRef.off();
    this.state.usersRef.child(`${this.state.user.uid}/likedArticles`).off();
  };

  isLiked(article) {
    return this.state.likedArticles.some((f) => {
      return f.id === article.id;
    });
  }

  addLike(article) {
    this.state.usersRef
      .child(`${this.state.user.uid}/likedArticles`)
      .push()
      .update(article)
      .then(() => {
        console.log("Article liked");
        this.closeModal();
      })
      .catch((err) => console.error(err));

    this.updateArticleLikeCount(article, 1);
  }

  getKey(article) {
    return this.state.likedArticles.find((f) => f.id === article.id).key;
  }

  removeLike(article) {
    this.state.usersRef
      .child(`${this.state.user.uid}/likedArticles`)
      .child(`${this.getKey(article)}`)
      .remove()
      .then(() => {
        console.log("Article unliked");
      })
      .catch((err) => console.error(err));

    this.updateArticleLikeCount(article, -1);
  }

  updateArticleLikeCount(article, parameter) {
    // console.log(article)
    let updatedArticle = { ...article };
    updatedArticle.likes += parameter;

    this.state.articlesRef
      .child(`${article.id}`)
      .update({ likes: updatedArticle.likes })
      .then(() => {
        console.log("Article unliked");
        this.setState({ article: updatedArticle });
      })
      .catch((err) => console.error(err));
  }

  handleLike(article) {
    if (this.isLiked(article)) this.removeLike(article);
    // console.log("Yes")
    else this.addLike(article);
    // console.log("No")
  }

  render() {
    const { article } = this.props;

    return (
      <React.Fragment>
        
        <Icon
          color="red"
          name={this.isLiked(article) ? "like" : "like outline"}
          onClick={() => this.handleLike(article)}
        />
        {article.likes}
        </React.Fragment>
      
    );
  }
}

const mapStateToProps = (state) => ({
  currentUser: state.user.currentUser,
});

export default connect(mapStateToProps)(ArticlesLikeButton);



// WEBPACK FOOTER //
// ./src/components/SidePanel/ArticlesLikeButton.js